import {
    ADD_OR_UPDATE_NEW_COUNTRY_SUCCESS,
    ADD_OR_UPDATE_NEW_COUNTRY_FAILED,
    RESET_ADD_OR_UPDATE_NEW_COUNTRY,
    LOADING_ADD_OR_UPDATE_NEW_COUNTRY,
    NETWORK_ERROR_ADD_OR_UPDATE_NEW_COUNTRY
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADD_OR_UPDATE_NEW_COUNTRY:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADD_OR_UPDATE_NEW_COUNTRY_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADD_OR_UPDATE_NEW_COUNTRY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_ADD_OR_UPDATE_NEW_COUNTRY:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_ADD_OR_UPDATE_NEW_COUNTRY:
            return (state = initialState);
        default:
            return state;
    }
};
